"use client";

import { create } from "zustand";

export interface BreadcrumbCategoryItem {
    label: string;
    href?: string;
}

interface BreadcrumbCategoriesModalState {
    open: boolean;
    crumbs: BreadcrumbCategoryItem[];
    openModal: (crumbs: BreadcrumbCategoryItem[]) => void;
    close: () => void;
}

/** Estado global do bottom-sheet de categorias acionado pelo breadcrumb. */
export const useBreadcrumbCategoriesModal = create<BreadcrumbCategoriesModalState>((set) => ({
    open: false,
    crumbs: [],
    openModal: (crumbs) => set({ open: true, crumbs }),
    close: () => set({ open: false }),
}));
